import { MoreVertical, BookOpen, Pencil } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useState } from 'react';
import references from '@/lib/parameterReferences.json';

export default function ParameterCalculator({ parameter, spec, onRemove, savedCalculations = [] }) {
  const [open, setOpen] = useState(false);
  const reference = references[parameter];
  return <>
    <DropdownMenu>
      <DropdownMenuTrigger asChild><button type="button" className="parameter-more" aria-label={`Actions for ${parameter}`}><MoreVertical size={18}/></button></DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => setOpen(true)}><BookOpen className="mr-2 h-4 w-4"/>Formula reference</DropdownMenuItem>
        {savedCalculations.map(item => <DropdownMenuItem key={item.label} onSelect={item.onRemove}><Pencil className="mr-2 h-4 w-4"/>Use entered value: {item.label}</DropdownMenuItem>)}
        {spec && <DropdownMenuItem onSelect={onRemove}><Pencil className="mr-2 h-4 w-4"/>Use entered value instead</DropdownMenuItem>}
      </DropdownMenuContent>
    </DropdownMenu>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[calc(100%-2rem)] sm:max-w-xl max-h-[85vh] overflow-y-auto rounded-xl p-6 sm:p-8">
        <DialogHeader className="text-left pr-5">
          <p className="text-xs font-medium uppercase tracking-widest text-green-800">Formula reference</p>
          <DialogTitle className="text-xl text-green-950 leading-snug">{reference?.title}</DialogTitle>
          <DialogDescription className="leading-relaxed pt-2">{reference?.meaning}</DialogDescription>
        </DialogHeader>
        <section className="rounded-lg bg-green-50/70 border border-green-100 p-4 sm:p-5">
          <h3 className="text-xs font-semibold uppercase tracking-wide text-green-900 mb-3">Formula / method</h3>
          <p className="text-sm leading-7 text-slate-800 break-words">{reference?.formula}</p>
          <p className="text-xs text-slate-500 mt-4">Workbook unit: {reference?.unit}</p>
        </section>
        <div className="divide-y divide-slate-100">
          {[['Scoring & transparency', [reference?.scoring, reference?.transparency]], ['Why this method', [reference?.why]]].map(([label, paragraphs]) => <details key={label} className="py-3">
            <summary className="cursor-pointer text-sm font-medium text-slate-700">{label}</summary>
            <div className="space-y-3 pt-3">{paragraphs.map((text, index) => <p key={index} className="text-sm leading-relaxed text-slate-600">{text}</p>)}</div>
          </details>)}
        </div>
        <p className="text-xs leading-relaxed text-slate-500">Source: UPSI_V3.5.xlsx · Definations · {reference?.range}. Workbook guidance only; use the unit shown in your input row. This reference does not calculate or change your values.</p>
      </DialogContent>
    </Dialog>
  </>;
}
